import * as React from 'react';

// Submodules
import { getEnvVar } from '../submodules/utils/ReactScriptHelper';

import utils = egr.wcf.utils;

const customLogoSrc: string = getEnvVar('CUSTOM_LOGO', '');

export class CustomLogo extends React.PureComponent<{}> {
    public render(): JSX.Element | null {
        if (utils.string.isNullOrEmpty(customLogoSrc)) {
            return null;
        }
        return (
            <div className="custom-logo"><img src={customLogoSrc}/></div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CustomLogo.tsx